import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RegionState } from 'types';

export const initialState: any = {
  loading: false,
  dealDetails: [],
  reset: false,
  totalCount: 0,
  currentPage: 1,
  pageSize: 10,
  partNo: [],
  filter: {
    manufacture: '',
    distributor: ''
  }
};

const slice = createSlice({
  name: 'Region',
  initialState,
  reducers: {
    setDealDetails: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.dealDetails = payload.response || [];
      state.reset = false;
    },
    setPartNo: (state, { payload }: PayloadAction<any>) => {
      state.partNo= payload.data
    },
    reset: (state) => {
      state.reset = true;
    },
    setFilter: (state, { payload }: PayloadAction<any>) => {
      const filter = { ...payload };
        state.filter = filter;
    },
    setRep: (state, { payload }: PayloadAction<any>) => {
      state.rep = payload;
    },
    setTotalCount: (state, { payload }: PayloadAction<any>) => {
      state.totalCount = payload;
    },
    setCurrentPage: (state, { payload }: PayloadAction<any>) => {
      state.currentPage = payload;
    },
    setPageSize: (state, { payload }: PayloadAction<any>) => {
      state.pageSize = payload;
    },
  }
});

export const { setDealDetails, reset, setFilter, setTotalCount, setCurrentPage, setPageSize, setPartNo, setRep } = slice.actions;

export default slice.reducer;
